import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ModalSidebarService {
  modalData = new BehaviorSubject<any>('');
  public _modalData = this.modalData.asObservable();

  modalShow = new BehaviorSubject<any>(false);
  public _modalShow = this.modalShow.asObservable();

  show: boolean = false;

  constructor() { 
    this.show = this.modalShow.value;
  }

  getModalData(): Observable<any> {
    return this.modalData;
  }

  setModalData(data, status) {
    this.modalData.next(data);
    this.modalShow.next(status);
  }

  closeModal() {
    this.modalShow.next(false);
  }
  
}
